// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingCircle_loader__yCw4r","spin":"LoadingCircle_spin__1XBwS"};